<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <h2 class="left">{{settings[selected].title}}</h2>
    <br class="clear">
    <br class="clear">
    <ng-template [ngIf]="selected == 'active'">
      <a routerLink="/partner/vendita/storico">
        <span class="btn btn-white  has-margin-right" id="storicoConsegne">Storico<i class="ml-10 far fa-folder"></i></span>
      </a>
    </ng-template>
    <ng-template [ngIf]="selected == 'inactive'">
      <button class="btn btn-white has-margin-right" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
        <i class="ml-10 fas fa-arrow-left"></i>Ritorna a Vendita
      </button>
    </ng-template>
  </div>
  <br class="clear">
</section>


<section class="main-content wrapper content-padding">
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner" *ngIf="selected == 'inactive'">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>

    <form class="table-row-container row first-row filter" [formGroup]="activityFilterForm" *ngIf="activityFilterForm" (ngSubmit)="filter()">

      <div class="item data-col-10 hideOnPhoneView">
        <h4 class="title" (click)="navigateOrder('PartnerShopifySaleActivity.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('PartnerShopifySaleActivity.id')"></i>
          ID
        </h4>
        <span class="data">
          <input type="number" min="1000" max="10000" formController="PartnerShopifySaleActivity.id">
        </span>
      </div>

      <div class="item data-col-20 hideOnPhoneView">
        <h4 class="title" (click)="navigateOrder('PartnerShopifySaleActivity.saleId')">
          <i class="sort-icon fas" [ngClass]="orderIcon('PartnerShopifySaleActivity.saleId')"></i>
          SALE ID
        </h4>
        <span class="data">
          <input type="text" formControlName="PartnerShopifySaleActivity.saleId" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
        </span>
      </div>

      <div class="item data-col-20 hideOnPhoneView">
        <h4 class="title" (click)="navigateOrder('PartnerShopifySaleActivity.orderId')">
          <i class="sort-icon fas" [ngClass]="orderIcon('PartnerShopifySaleActivity.orderId')"></i>
          ORDER ID
        </h4>
        <span class="data">
          <input type="text" formControlName="PartnerShopifySaleActivity.orderId" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
        </span>
      </div>

      <div class="item data-col-20 hideOnPhoneView">
        <h4 class="title" (click)="navigateOrder('PartnerShopifySaleActivity.status')">
          <i class="sort-icon fas" [ngClass]="orderIcon('PartnerShopifySaleActivity.status')"></i>
          STATUS
        </h4>
        <span class="data">
          <input type="text" formControlName="PartnerShopifySaleActivity.status" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
        </span>
      </div>

      <!--
      <div class="item data-col-5">
        <h4 class="title">SHOP</h4>
        <span class="data">
          <select formControlName="PartnerShopifySaleActivity.shop" style="width: 120px;">
            <option value="">Tutti</option>
            <option value="ShopifySale">Deluxy</option>
            <option value="CakeSales">Cakes</option>
            <option value="FlowersSales">Flowers</option>
            <option value="BusinessSales">Business</option>
          </select>
        </span>
      </div>
      -->

      <div class="item data-col-5 hideOnPhoneView">
        <h4 class="title">Azioni</h4>
        <span class="data saifu">
          <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
            <i class="fas fa-search"></i>
          </button>
          <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
            <i class="fas fa-undo"></i>
          </button>
        </span>
      </div>
      <hr class="hr-clear">
    </form>

    <div class="table-row-container row" *ngFor="let partnerShopifySaleActivity of partnerShopifySaleActivities">

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          ID
        </h4>
        <div class="data data-id">
          <div>{{ partnerShopifySaleActivity?.id || "---" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          SALE ID
        </h4>
        <div class="data">
            <div>{{ partnerShopifySaleActivity?.saleId || "---" }}</div>
        </div>
      </div>
  
      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          ORDER ID
        </h4>
        <div class="data">
          <div>{{ partnerShopifySaleActivity?.orderId || "---" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          STATUS
        </h4>
        <div class="data">
            <div>{{ partnerShopifySaleActivity?.status?.toUpperCase() || "---" }}</div>
        </div>
      </div>

      <!--
      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          SHOP
        </h4>
        <div class="data">
          <div>{{ partnerShopifySaleActivity?.shop?.toUpperCase() }}</div>
        </div>
      </div>
      -->

      <div class="item data-col-5">
        <h4 class="title"></h4>
        <span class="data saifu">
          <a (click)="$event.preventDefault(); deletePartnerShopifySaleActivity(partnerShopifySaleActivity?.id)">
            <span class="btn btn-red hvr-grow">Elimina<i class="ml-10 far fa-trash-alt"></i></span>
          </a>
        </span>
      </div>
    </div>
  </div>

  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner" *ngIf="selected == 'active'">
    <form class="table-row-container row first-row filter">
      <div class="item data-col-20 hideOnPhoneView">
        <h4 class="title">
          SALE ID
        </h4>
      </div>

      <div class="item data-col-20 hideOnPhoneView">
        <h4 class="title">
          ORDER ID
        </h4>
      </div>

      <div class="item data-col-20 hideOnPhoneView">
        <h4 class="title">
          SHOP
        </h4>
      </div>

      <div class="item data-col-20 hideOnPhoneView">
        <h4 class="title">
          SALETYPE
        </h4>
      </div>

      <div class="item data-col-5 hideOnPhoneView">
        <h4 class="title">Azioni</h4>
        <span class="data saifu"></span>
      </div>
      <hr class="hr-clear">
    </form>

    <div class="table-row-container row" *ngFor="let sales of salesToBeConfirm">

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          SALE ID
        </h4>
        <div class="data">
            <div>{{ sales?.saleId || "---" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          ORDER ID
        </h4>
        <div class="data">
            <div>{{ sales?.orderId || "---" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          SHOP
        </h4>
        <div class="data">
            <div>{{ showShopName(sales) }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          SALETYPE
        </h4>
        <div class="data">
            <div>{{ sales?.saleType?.toUpperCase() }}</div>
        </div>
      </div>

      <div class="item nowrap">
        <span class="data-row-left btn-container">

          <span *ngIf="sales?.saleType === 'unique'">
            <button class="btn hvr-grow has-margin-right" (click)="acceptSaleForUniqueProduct(sales.deliveryInfo)" [disabled]="saleBtn">ACCETTA</button>
            <button class="btn hvr-grow has-margin-right" (click)="refuseSaleForUniqueProduct(sales.deliveryInfo)" [disabled]="saleBtn">RIFIUTA</button>
          </span>

          <span *ngIf="sales?.saleType === 'nonunique'">
            <button class="btn hvr-grow ha  s-margin-right" (click)="acceptSaleForNonUniqueProduct(sales.token, sales.deliveryInfo)" [disabled]="saleBtn">ACCETTA</button>
            <button class="btn hvr-grow has-margin-right" (click)="refuseSaleForNonUniqueProduct(sales.token, sales.deliveryInfo)" [disabled]="saleBtn">RIFIUTA</button>
          </span>
          <button class="btn hvr-grow has-margin-right" (click)="showSaleInfo(sales.token, sales.deliveryInfo)">DETAILS</button>

        </span>
      </div>
    </div>
  </div>
</section>

<div *ngIf="showAddressModal && selectedPartner" class="amp-backdrop">
    <div class="amp-box">

        <div class="amp-header">
            <div class="amp-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                Indirizzi Multipli
            </div>
            <h3 class="amp-title"><span class="amp-partner-name">{{ selectedPartner.businessName }}</span> ha piÃ¹ indirizzi salvati</h3>
            <p class="amp-subtitle">Seleziona un indirizzo di ritiro per proseguire con questo ordine.</p>
        </div>

        <div class="amp-divider"></div>

        <div class="amp-default-block">
            <div class="amp-default-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <span>Indirizzo Predefinito</span>
                <span class="amp-default-tag">Predefinito</span>
            </div>
            <p class="amp-default-address">{{ selectedPartner.address }}</p>
        </div>

        <div class="amp-section-label">Seleziona un indirizzo alternativo</div>

        <div class="amp-list">
            <label
                *ngFor="let addr of partnerPickupAddresses"
                class="amp-item"
                [class.amp-item--selected]="selectedPickupAddress === addr"
                [class.amp-item--disabled]="isConfirming">
                <input
                    type="radio"
                    [value]="addr"
                    [(ngModel)]="selectedPickupAddress"
                    [disabled]="isConfirming">
                <div class="amp-radio-dot">
                    <div class="amp-radio-inner"></div>
                </div>
                <div class="amp-address-text">
                    <span class="amp-address-label">{{ addr }}</span>
                </div>
                <svg class="amp-pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
            </label>
        </div>

        <div class="amp-footer">
            <button type="button" class="amp-btn amp-btn--cancel" (click)="handleAddressModal()" [disabled]="isConfirming">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                Annulla
            </button>
            <button type="button" class="amp-btn amp-btn--confirm" (click)="confirmPickupAddress()" [disabled]="isConfirming || !selectedPickupAddress">

                <span *ngIf="isConfirming" class="amp-spinner"></span>

                <ng-container *ngIf="!isConfirming">
                    Conferma Indirizzo
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </ng-container>

                <ng-container *ngIf="isConfirming">
                    Caricamento...
                </ng-container>
            </button>
        </div>
    </div>
</div>